import { graphql } from "relay-runtime"

export const BillingAttributeFragment = graphql`
  fragment BillingAttributeFragment on BillingAttribute {
    id
    isNotBillable
    notBillableReason
    treatmentReason
    reason
    isVisualSymptomExamination
    currentGestationWeek
    organisationId
    dateOfAccident
    accidentReference
    isEmployer
    lawType
    ivgCaseReference
    mvgCaseReference
  }
`
